<template>
	<div>
		<div style="background-color: #fff;padding: 2% 5%;text-align: left;">
			<el-form :model="form" :inline="true">
				<el-form-item label="运单号">
					<el-input v-model="form.waybillNo" style="width: 20vw;" type="textarea" :rows="4"
						placeholder="请输入运单号，每行一条，最多20条" resize="none"></el-input>
				</el-form-item>
				<el-form-item label="快递公司">
					<el-select v-model="form.cpCode" placeholder="请选择快递公司">
						<el-option v-for="item in cpList" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
					<div style="position: relative;top: 4vh;">
						<el-checkbox v-model="isDataItemOpen" style="right: 30%;">展开所有</el-checkbox>
						<el-button @click="query_button(form.cpCode,form.waybillNo,form.phone)" type="primary"
							:icon="Search">查询</el-button>
					</div>
				</el-form-item>
			</el-form>
		</div>

		<div style="padding: 1% 1%;background-color: #fff;margin-top:1vh;min-height:70vh;cursor: pointer;">
			<el-collapse v-if="data.length>0" v-model="dataItemOpenList">
				<el-collapse-item v-for="(i,index) in data" :key="index" :name="String(index)">
					<template #title>
						<div
							style="display: flex;align-items: center;font-size: 1em;font-family: sans-serif;color: #47494c;padding-left: 2%;">
							<el-avatar :src="global.expressLogoUrl+i.cpCode+'.png'" :size="22"></el-avatar>
							<span style="font-weight: 600;margin: 0 1em 0 0.4em;">{{i.cpName}}</span>
							<span>{{i.waybillNo}}</span>
							<el-tag effect="dark"
								style="margin: 0 1.5em;">{{i.route.length <1 ? '未发出' : i.route[0]['statusCode'] == 'SIGN'||i.route[0]['text'].includes('已签收') ? '已签收': '运输中'}}</el-tag>
							<el-tag>全程耗时：{{timeConsuming(i.route)}} 小时</el-tag>
						</div>
					</template>

					<el-table :data="i.route" border :header-cell-style="{background:'#f4f4f4',color:'#2f2f2f','font-family': 'sans-serif','font-weight': 400}"
						style="width: 100%;font-family: sans-serif;color: #606266;">
						<el-table-column prop="time" label="操作时间" width="160"></el-table-column>
						<el-table-column prop="text" label="物流信息">
							<template #default="scope">
								<span>{{scope.row.text}}</span>
								<span v-if="scope.row.weight">{{scope.row.weight}}公斤</span>
							</template>
						</el-table-column>
					</el-table>
					<div v-if="!i.route" style="position: relative;left: -4%;">
						<el-empty description="暂无数据"></el-empty>
					</div>
				</el-collapse-item>
			</el-collapse>
		</div>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				form: {
					waybillNo: '',
					cpCode: "",
					phone: ""
				},
				cpList: [{
						value: '',
						label: '自动识别'
					},
					{
						value: 'ZTO',
						label: '中通快递'
					}, {
						value: 'YTO',
						label: '圆通速递'
					}, {
						value: 'STO',
						label: '申通快递'
					}, {
						value: 'YD',
						label: '韵达速递'
					}, {
						value: 'JT',
						label: '极兔速递'
					}, {
						value: 'POST',
						label: '中国邮政(含EMS)'
					}, {
						value: 'SF',
						label: '顺丰速运'
					}
				],
				data: [],
				dataItemOpenList: [],
				isDataItemOpen: false
			}
		},
		methods: {
			query(cpCode, waybillNo, phone) {
				console.log(cpCode, waybillNo)
				if (waybillNo) { //判断运单号
					this.data = []
					this.apiService.post({
							modules: "waybillRoute",
							content: {
								cpCode: cpCode,
								waybillNo: waybillNo,
								phone: phone,
								sort: "1"
							}
						})
						.then((res) => {
							//成功
							if (res.status) {
								this.data.unshift(res.data);
								if (this.data.length < 1) {
									this.$message({
										message: '暂无物流轨迹信息',
										type: 'warning'
									});
								}
							}
						})

				} else {
					this.$message.error('请输入运单号');
				}
			},
			query_button(cpCode, waybillNo) {
				var waybillNoList = []
				waybillNo.trim().split("\n").filter((e) => {
					var waybillNo_item = e.replace(/[^a-z0-9]/gi, '')
					if (waybillNo_item) {
						// Vue3 响应式数组需通过 .value 操作
						waybillNoList.push(waybillNo_item)
					}
				});
				//超过20则只取前20个
				if (waybillNoList.length > 20) {
					waybillNoList = waybillNoList.slice(0, 20)
				}
				if (this.isDataItemOpen) {
					this.dataItemOpenList = Array.from({
						length: waybillNoList.length
					}, (value, key) => String(key))
				}
				if (waybillNoList.length == 1) {
					this.dataItemOpenList = ['0']
				}
				for (var waybillNoItem of waybillNoList) {
					if (cpCode == "SF") {
						this.$prompt('请输入收或发件人电话号码', '快递公司要求', {
							confirmButtonText: '提交',
							inputPattern: /(^1\d{10}$)/,
							inputErrorMessage: '请输入11位手机号码或4位尾号'
						}).then(({
							value
						}) => {
							this.form.phone = value
							this.query(cpCode, waybillNoItem, value)
						}).catch(() => {
							console.log("用户取消输入")
						});
					} else {
						this.query(cpCode, waybillNoItem, this.form.phone)
					}
				}
			},
			//计算最新轨迹耗时
			timeConsuming(route) {
				if (route.length > 0) {
					var date1 = new Date(route[route.length - 1]['time'])
					var date2 = new Date()
					//如果是签收了取签收时间，没签收则取现在时间来计算运输耗时，关闭会刷新时间
					if (route[0]['statusCode'] == 'SIGN' || route[0]['text'].includes('已签收')) {
						date2 = new Date(route[0]['time'])
						console.log(date1)
					}
					const diff = Math.abs(date2 - date1); // 计算两个日期时间的差值（毫秒）
					const hours = diff / (1000 * 60 * 60); // 转换为小时
					return hours.toFixed(2); // 返回2位小数的小时数
				} else {
					return 0
				}
			}

		},
		created() {
			var cpCode = this.$route.query.cpCode;
			var waybillNo = this.$route.query.waybillNo;
			if (!cpCode) {
				cpCode = ""
			}
			if (waybillNo) {
				this.query_button(cpCode, waybillNo);
			}
			this.form.cpCode = cpCode;
			this.form.waybillNo = waybillNo;
		}
	}
</script>

<style scoped>
	/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
	.trail_show_window::-webkit-scrollbar {
		width: 7px;
		height: 7px;
		background-color: #fcfcfc;
	}

	/*定义滚动条轨道 内阴影+圆角*/
	.trail_show_window::-webkit-scrollbar-track {
		box-shadow: inset 0 0 6px rgba(244, 244, 244, 0.3);
		-webkit-box-shadow: inset 0 0 6px rgba(240, 240, 240, 0.3);
		border-radius: 10px;
		background-color: #f5f5f5;
	}

	/*定义滑块 内阴影+圆角*/
	.trail_show_window::-webkit-scrollbar-thumb {
		border-radius: 10px;
		box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
		-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
		background-color: #dadada;
	}
</style>